<template>
  <div class="content">
    <div class="form-container">
      <a-spin :spinning="loading">
        <a-form :form="form" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <div class="title">{{ title }}</div>
          <template v-for="item in configList">
            <a-form-item
              :key="item.key"
              v-if="handleShow(item.code, 'codeList')"
            >
              <span slot="label"
                >{{ item.title }}
                <a-tooltip>
                  <template slot="title">{{ item.helptext }} </template>
                  <a-icon type="info-circle" style="margin: 0 6px 0 8px" />
                </a-tooltip>
              </span>
              <a-input
                v-if="handleShow(item.code, 'inputCodeList')"
                class="form-item"
                :placeholder="item.desc"
                v-decorator="[item.code, { initialValue: item.val }]"
              />
              <UploadImage
                v-if="handleShow(item.code, 'uploadCodeList')"
                :needSplit="true"
                @handleFileList="url => handleImageList(url, item.code)"
                v-decorator="[item.code]"
              />
              <div v-if="item.code == 'upload'">
                <Upload
                  :accept="'.zip, .doc, .docx, .pdf, .jpg, .png'"
                  @handleFileList="handleFileList"
                  :fileList="fileList"
                  v-decorator="[item.key]"
                  :deleteUrl="
                    'wechatwork-content-biz/content/article/attachment/del'
                  "
                >
                </Upload>
                <span class="pdf"
                  >支持扩展名：.zip, .doc, .docx, .pdf, .jpg, .png</span
                >
              </div>
              <div
                class="form-switch"
                v-if="handleShow(item.code, 'wechatCodeList')"
              >
                <a-radio-group :default-value="item.val">
                  <a-radio value="1">有 </a-radio>
                  <a-radio value="0"> 无 </a-radio>
                </a-radio-group>
              </div>

              <a-select v-if="item.type == 'select'" default-value="lucy">
                <a-select-option value="jack"> Jack </a-select-option>
                <a-select-option value="lucy"> Lucy </a-select-option>
                <a-select-option value="disabled" disabled>
                  Disabled
                </a-select-option>
                <a-select-option value="Yiminghe"> yiminghe </a-select-option>
              </a-select>
              <div
                class="form-switch"
                v-if="handleShow(item.code, 'switchCodeList')"
              >
                <a-switch
                  checked-children="on"
                  un-checked-children="off"
                  v-decorator="[
                    item.code,
                    {
                      initialValue: item.val == '' ? false : true,
                      valuePropName: 'checked'
                    }
                  ]"
                />
              </div>

              <div
                v-if="handleShow(item.code, 'tagCodeList')"
                class="tag-content"
              >
                <a-tag
                  closable
                  v-for="ele in item.val"
                  :key="ele.name"
                  @close="e => closeTag(e, item.code, ele.name)"
                  >{{ ele.name }}
                </a-tag>

                <div
                  class="addtags"
                  @click="handleModal(item.code)"
                  v-if="!item.val || item.val == '' || item.val.length < 6"
                >
                  <a-icon type="plus-circle" />
                  添加自定义信息
                </div>
              </div>
            </a-form-item>
          </template>
        </a-form>
      </a-spin>
    </div>
    <div class="drawer-bootom-button">
      <a-button style="margin-right: 0.8rem" @click="resetConfig"
        >重置</a-button
      >
      <a-button type="primary" @click="submitForm">提交</a-button>
    </div>
    <!-- 对外信息 -->
    <a-modal
      :width="600"
      :visible="visible"
      title="企业成员对外信息配置"
      @cancel="cancelModal"
    >
      <a-form :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-form-item label="对外信息">
          <a-input placeholder="请输入对外信息名称" v-model="name" />
        </a-form-item>
        <a-form-item
          label="信息类型"
          style="display: flex; align-items: center"
        >
          <a-radio-group name="radioGroup" v-model="type">
            <a-radio :value="0"> 文本 </a-radio>
            <a-radio :value="1"> 链接 </a-radio>
            <a-radio :value="2"> 小程序 </a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>

      <template slot="footer">
        <a-button @click="cancelModal"> 取消 </a-button>
        <a-button type="primary" @click="submitInfo"> 确定 </a-button>
      </template>
    </a-modal>
    <!-- 对外信息 end -->
  </div>
</template>
<script>
import UploadImage from '@/components/common/UploadImage';
import Upload from '@/components/common/Upload';
import { editApiConfig } from '@/api/system';
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      picurl: '',
      fileList: [],
      inputCodeList: [
        'WEB_COMPANY_NAME',
        'WEB_TITLE',
        'MIDDLE_PLATFORM_TITLE',
        'MIDDLE_PLATFORM_SYS_NAME',
        'MIDDLE_PLATFORM_LOGIN_WORDS',
        'WECHAT_NAME',
        'WECHAT_ACTIVATION_CODE_LINK',
        'WECHAT_SESSION_ARCHIVE_KEY_FILE',
        'MIDDLE_PLATFORM_LOGIN_TITLE'
      ],
      uploadCodeList: [
        'WEB_LOGO',
        'WEB_LABEL_ICON',
        'MIDDLE_PLATFORM_LABEL_ICON',
        'MIDDLE_PLATFORM_LOGO',
        'MIDDLE_PLATFORM_LOGIN_LOGO',
        'MIDDLE_PLATFORM_MIN_LOGO'
      ],
      tagCodeList: ['WECHAT_MEMBER_EXTERNAL_INFO'],
      switchCodeList: ['WECHAT_ADDRESS_BOOK'],
      wechatCodeList: ['WECHAT_FLAG'],
      codeList: [
        'WEB_COMPANY_NAME',
        'WEB_TITLE',
        'MIDDLE_PLATFORM_TITLE',
        'MIDDLE_PLATFORM_SYS_NAME',
        'MIDDLE_PLATFORM_LOGIN_WORDS',
        'WECHAT_NAME',
        'WECHAT_ACTIVATION_CODE_LINK',
        'WECHAT_SESSION_ARCHIVE_KEY_FILE',
        'MIDDLE_PLATFORM_LOGIN_TITLE',
        'WEB_LOGO',
        'WEB_LABEL_ICON',
        'MIDDLE_PLATFORM_LABEL_ICON',
        'MIDDLE_PLATFORM_LOGO',
        'MIDDLE_PLATFORM_LOGIN_LOGO',
        'MIDDLE_PLATFORM_MIN_LOGO',
        'WECHAT_MEMBER_EXTERNAL_INFO',
        'WECHAT_ADDRESS_BOOK',
        'WECHAT_FLAG'
      ],
      visible: false, //添加自定义信息
      loading: false,
      name: '',
      type: 0,
      currentCode: ''
    };
  },
  props: {
    configList: {
      type: Array,
      default: []
    },
    title: {
      type: String,
      default: ''
    }
  },
  components: {
    UploadImage,
    Upload
  },
  watch: {
    configList(val) {
      this.$nextTick(() => {
        val.forEach(item => {
          this.form.setFieldsValue({ [item.code]: item.val });
        });
      });
    }
  },
  methods: {
    handleImageList(url, code) {
      let obj = this.configList.find(item => item.code == code);
      obj.val = url.fileName;
      this.form.setFieldsValue({
        [code]: url.fileName
      });
    },
    handleFileList(fileList) {
      // let list = fileList;
      // this.attachments = [];
      // if (fileList && fileList.length > 0) {
      //   list.forEach((item) => {
      //     let obj = {
      //       attachmentName: item.name,
      //       attachmentPath: item.url,
      //     };
      //     this.attachments.push(obj);
      //   });
      // } else {
      //   this.attachments = [];
      // }
    },
    handleShow(code, key) {
      let index = this[key].findIndex(item => item == code);

      return index > -1 ? true : false;
    },
    closeTag(e, code, name) {
      e.preventDefault();
      let obj = this.configList.find(item => item.code == code);
      let index = obj.val.findIndex(el => el.name == name);
      obj.val.splice(index, 1);
    },
    cancelModal() {
      this.visible = false;
    },
    handleModal(code) {
      this.visible = true;
      this.currentCode = code;
    },
    submitInfo() {
      let obj = this.configList.find(item => item.code == this.currentCode);
      let arr = [];
      arr.push({
        type: this.type,
        name: this.name
      });
      if (obj.val == '') {
        obj.val = arr;
      } else {
        obj.val = obj.val.concat(arr);
      }
      this.visible = false;
      //重置
      this.name = '';
      this.type = 0;
    },
    submitForm() {
      let param = [];
      this.configList.forEach(item => {
        this.form.validateFields((error, values) => {
          let obj = {
            code: item.code,
            val: values[item.code]
          };
          param.push(obj);
        });
      });
      console.log(param, 'param');
      this.loading = true;
      editApiConfig(param).then(res => {
        console.log('res+++', res);
        if (res.success) {
          this.loading = false;
          this.$message.success(res.message);
          this.$emit('handlConfig');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    resetConfig() {
      this.form.resetFields();
      this.$emit('handlConfig');
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  padding-top: 40px;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  // overflow: hidden;
  .title {
    height: 40px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 22px;
    margin-bottom: 24px;
    padding-left: 40px;
  }
  .form-container {
    padding-bottom: 60px;
    flex: 1;
    overflow: auto;
  }
  .drawer-bootom-button {
    bottom: 0;
    width: 100%;
    height: 60px;
    border-top: 1px solid #e8e8e8;
    text-align: right;
    background: #fff;
    border-radius: 0 0 2px 2px;
    padding: 10px 16px;
  }
}
// /deep/.ant-form {
//   height: 100%;
//   overflow: auto;
// }
/deep/.ant-form .ant-form-item .ant-form-item-children {
  display: flex;
  input {
    width: 300px;
    margin-left: 8px;
  }
  .ant-upload-select {
    margin-left: 8px;
  }
  .ant-select {
    width: 300px;
    margin-left: 8px;
  }
  .ant-switch {
    margin-left: 8px;
  }
}
.tag-content {
  height: 40px;
  display: flex;
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
  align-items: center;
  .ant-tag {
    cursor: pointer;
    height: 31px;
    line-height: 31px;
  }
  .addtags {
    cursor: pointer;
    margin-left: 50px;
  }
}
</style>
